import { currentView, selectedPropertyId } from '../state'

/**
 * Navigates back to the accounts view from properties view
 */
export const goBackToAccounts = () => {
  currentView.value = 'accounts'
  selectedPropertyId.value = null
}
